import "magnific-popup";
$(document).ready(function() {
  (() => {
    const magnificInits = {
      init() {
        this.productImage();
        this.youtubePlayer();
      },
      productImage() {
        const magnificImage = $("[data-open-magnific-image]");

        if (magnificImage.length) {
          magnificImage.magnificPopup({
            type: "image"
          });
        }
      },
      youtubePlayer() {
        const magnificYouTube = $("[data-open-magnific-youtube]");

        if (magnificYouTube.length) {
          magnificYouTube.magnificPopup({
            type: "iframe"
          });
        }
      }
    };

    magnificInits.init();
  })();
});
